// Syncs authenticated user identity into analytics.

import { useEffect } from 'react';
import { analyticsService } from '../services/analyticsService';
import { useAuth } from './useAuth';

export const useAnalyticsIdentity = () => {
  const { user } = useAuth();

  useEffect(() => {
    if (!user) {
      analyticsService.setUserId(null);
      return;
    }

    analyticsService.setUserId(user._id);
    analyticsService.setUserProperties(user);
  }, [user]);
};
